import {useState, useEffect} from 'react'
import secureLocalStorage from 'react-secure-storage'
import {baseUrl} from '../../core'
import usePostApi from '../../custom_hooks/usePostApi'
import Swal from 'sweetalert2'
import {useIntl} from 'react-intl'

function AssetManager({managerDetails}) {
  const {execute} = usePostApi()
  const {
    manager_approved_status = null,
    manager_approved_comments = '',
    fetchData = () => {},
    employee_asset_id = '',
    assetData,
  } = managerDetails

  let emp_id
  let organization_id
  let role
  let is_manager
  const userInfo = secureLocalStorage.getItem('user_info')
  if (userInfo) {
    ;({emp_id, organization_id, role, is_manager} = userInfo)
  }

  const intl = useIntl()
  const [managerComment, setManagerComment] = useState('')
  const [comError, setComError] = useState(false)
  const [comLenErr, setComLenErr] = useState(false)

  useEffect(() => {
    if (managerComment !== '') {
      setComError(false)
    }
    if (managerComment.length >= 3) {
      setComLenErr(false)
    }
  }, [managerComment])

  const approveAndRejectBtns = async (event) => {
    if (managerComment === '') {
      setComError(true)
      return
    } else if (managerComment.length < 3) {
      setComLenErr(true)
      return
    }

    try {
      const url = `${baseUrl}/assetManagement/empAssets/manager/${employee_asset_id}`

      const formData = {
        organization_id: organization_id,

        manager_approved_status: event.target.name,

        manager_approved_comments: managerComment,
        approved_status: event.target.name == 'Approved' ? 'Pending' : event.target.name,
        request_status: event.target.name == 'Approved' ? 'IT Admin Pending' : event.target.name,
        manager_reviewed_by: emp_id,
      }

      // Determine the success message based on the request_status
      await execute(url, 'PATCH', formData)
      fetchData()

      assetData()
      const successMessage =
        event.target.name === 'Approved'
          ? intl.formatMessage({id: 'MSG.REQUEST_APPROVED_SUCCESSFULLY'})
          : intl.formatMessage({id: 'MSG.REQUEST_REJECTED_SUCCESSFULLY'})

      await Swal.fire({
        title: successMessage,
        text: intl.formatMessage({id: 'LABEL.CHANGES_SAVED'}),
        icon: 'success',
        customClass: {
          confirmButton: 'btn btn-light-primary btn-sm',
        },
      })
    } catch (error) {
      console.error('Error:', error)
      Swal.fire({
        icon: 'error',
        title: intl.formatMessage({id: 'LABEL.OOPS'}),
        text: intl.formatMessage({id: 'LABEL.SOMETHING_WRONG'}),
        customClass: {
          confirmButton: 'btn btn-light-primary btn-sm',
        },
      })
    }
  }

  useEffect(() => {
    setManagerComment('')

    setComError(false)
    setComLenErr(false)
  }, [])

  const getManagerView = (status) => {
    if (status === 'Pending' && is_manager === 1) {
      return (
        <div className='min-h-26px'>
          <label> {intl.formatMessage({id: 'LABEL.COMMENTS'})}</label>
          <br />
          <textarea
            placeholder='Comments'
            className='form-control mb-3 form-control-solid'
            value={managerComment}
            onChange={(e) => setManagerComment(e.target.value)}
          />
          {comError && <p className='text-danger'>Comments is Required</p>}
          {comLenErr && !comError && (
            <p className='text-danger'>Comments must be at least 3 characters</p>
          )}
          <div>
            <button
              className='btn btn-light-success btn-sm py-2'
              name='Approved'
              onClick={approveAndRejectBtns}
              type='submit'
              // id='side_activities_close'
            >
              {intl.formatMessage({id: 'LABEL.APPROVE'})}
            </button>
            <button
              className='btn btn-light-danger btn-sm ms-2 py-2'
              name='Rejected'
              onClick={approveAndRejectBtns}
              type='submit'
              // id='side_activities_close'
            >
              {intl.formatMessage({id: 'LABEL.REJECT'})}
            </button>
          </div>
        </div>
      )
    } else if (status === 'Approved' || status === 'Rejected') {
      return (
        <>
          {/* <p className='m-0 text-muted'>{status}</p> */}
          <p className='m-0 text-muted'>{manager_approved_comments}</p>
        </>
      )
    } else {
      return null
    }
  }

  const getStatusMsg = (approvedstatus) => {
    if (approvedstatus === 'Pending' || approvedstatus === '') {
      return 'Pending'
    } else if (approvedstatus === 'Rejected') {
      return 'Rejected'
    } else if (approvedstatus === 'Approved') {
      return manager_approved_status
    } else {
      return approvedstatus
    }
  }

  const getStatusColor = (approvedstatus) => {
    if (approvedstatus === 'Pending' || approvedstatus === '') {
      return 'muted'
    } else if (approvedstatus === 'Approved') {
      return 'success'
    } else {
      return 'danger'
    }
  }

  return (
    <div className='timeline-item'>
      <div className='timeline-line w-20px'></div>

      <div className='timeline-icon symbol symbol-circle symbol-20px'>
        <div
          className={`symbol-label bg-${getStatusColor(
            manager_approved_status
          )} icon-dotted-border text-${getStatusColor(manager_approved_status)}`}
        ></div>
      </div>

      <div className='timeline-content mb-12 mt-n1'>
        <div className='d-flex justify-content-between mt-1'>
          <p className={`mb-0 fw-bold text-${getStatusColor(manager_approved_status)}`}>
            {getStatusMsg(manager_approved_status)}
          </p>
          <div className=''>
            <p className='designation-btn bg-secondary fs-7 m-auto'>Manager</p>
          </div>
        </div>
        {getManagerView(manager_approved_status)}
      </div>
    </div>
  )
}

export default AssetManager
